import type { ReactNode } from 'react';

const TransactionDetailsContent = ({ children }: { children?: ReactNode }) => (
	<div className='transaction-details_content bg-primary-400 border-dark-navy'>{children}</div>
);

export default TransactionDetailsContent;
